import angular from 'angular';
import $ from 'jquery';
import template from './template.html';
import './style.scss';

export class TFTNotification {
    /* @ngInject */
    constructor($timeout, $element, NOTIFICATION_CONSTS) {
        this.$timeout = $timeout;
        this.$element = $element;
        this.NOTIFICATION_CONSTS = NOTIFICATION_CONSTS;
    }

    $onInit() {
        this.setup();
        this.show();
    }

    setup() {
        const typeHash = {
            [this.NOTIFICATION_CONSTS.TYPE.INFO]: {
                className: 'alert-info',
                icon: 'msg-info',
            },
            [this.NOTIFICATION_CONSTS.TYPE.WARNING]: {
                className: 'alert-warning',
                icon: 'msg-info',
            },
            [this.NOTIFICATION_CONSTS.TYPE.SUCCESS]: {
                className: 'alert-success',
                icon: 'msg-success',
            },
            [this.NOTIFICATION_CONSTS.TYPE.ERROR]: {
                className: 'alert-danger',
                icon: 'msg-error',
            },
        };

        this.className = typeHash[this.message.type].className;
        this.icon = typeHash[this.message.type].icon;
        this.iconPath = `../assets/img/icons/build/svg-sprite.svg#${this.icon}`;
        this.element = $(this.$element.find('div'));
        this.antimationDuration = this.message.animationDuration || this.NOTIFICATION_CONSTS.DEFAULT_ANIMATION_DURATION;
        this.duration = this.message.duration || this.NOTIFICATION_CONSTS.DEFAULT_DURATION;
    }

    show() {
        this.element
            .animate({ top: '0' }, this.animationDuration)
            .promise()
            .then(() => this.timer = this.$timeout(() => this.close(), this.duration));
    }

    close() {
        this.$timeout.cancel(this.timer);
        this.timer = null;
        this.element
            .animate({ top: '-55px' }, this.animationDuration)
            .promise()
            .then(() => this.onClose());
    }
}

export const TFTNotificationConfiguration = {
    template,
    controller: TFTNotification,
    bindings: {
        message: '<',
        onClose: '&',
    },
    controllerAs: 'notificationCtrl',
};

angular
    .module('TALENYA-FE')
    .component('tftNotification', TFTNotificationConfiguration);
